import React from 'react';
import { Index } from 'react-instantsearch-hooks-web';
import SearchTabToggle from './SearchTabToggle';
import { useSearchStateIndex, useSearchStateIndexDispatch } from './hooks/useSearchStateIndex';
import config from './config/config';

const SearchTabs = ( ) => {
	const dispatch = useSearchStateIndexDispatch();
	const { activeIndexName } = useSearchStateIndex();

	return (
		<div className='tw-relative'>
			<div className='tw-flex tw-pt-8 before:tw-w-full before:tw-animate-fade-in before:tw-border-b before:tw-border-platinum before:tw-z-index-0 before:tw-content-[""] before:tw-absolute before:tw-bottom-0'>
				<Index indexName={`${ config.ALGOLA_ENV }_${ config.ALGOLIA_INDEX_DEFAULT }`} indexId={`${ config.ALGOLIA_INDEX_DEFAULT }_tabs`}>
					<SearchTabToggle
						onClick={() => {
							dispatch( {
								type: 'changed',
								index: 'neighborhoods',
							} );
						}}
						isActive={activeIndexName.includes( 'neighborhoods' )}
						label="Neighborhoods"
					/>

				</Index>
				<Index indexName={`${ config.ALGOLA_ENV }_${ config.ALGOLIA_INDEX_HOMES }`} indexId={`${ config.ALGOLIA_INDEX_HOMES }_tabs`}>
					<div className="ml-3 lg:ml-8">
						<SearchTabToggle
							onClick={() => {
								dispatch( {
									type: 'changed',
									index: 'homes',
								} );
							}}
							isActive={activeIndexName.includes( 'homes' )}
							label="Homes & Floorplans"
						/>
					</div>
				</Index>
			</div>
		</div>
	);
};

export default SearchTabs;
